// removed by extract-text-webpack-plugin
module.exports = {"intro":"_3yXZD9y9EDhGVqmKSabfN_","magasine":"_38ePQtMR714XcGHmaJIg9x"};


//////////////////
// WEBPACK FOOTER
// ./about/styles.module.css
// module id = 456
// module chunks = 0